import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const create = async ({
  requesterId,
  commentes,
  remarked,
  newDeadLine,
  idAction,
  groupMinutes,
}) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/followups`,
      {  
        requesterId,
        commentes,
        remarked,
        newDeadLine,
        idAction,
        groupMinutes,
      }
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
}

export const update = async ({
  commentes,
  remarked,
  newDeadLine,
  idAction,
  groupMinutes,
  fupId
}) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/followups/${fupId}`,
      {
        commentes,
        remarked,
        newDeadLine,
        idAction,
        groupMinutes,
      }
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
}
